import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ApiService from '../service/ApiService';
import { withRouter } from '../ganchos/withRouter';
import { toast } from 'react-toastify';
import IconeHay from "../images/logo-loading.png";
import lodash from "lodash";
import utilService from '../service/UtilService';
import { Link } from 'react-router-dom';
import Modal from '../components/ui/modal';

class MenuInicial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liberacaoConfiancaVisivel: false,
            escolherNumeroVisivel: false,
            telefones: [],
            mostrarLiberacaoConfiancaSucesso: false,
            mostrarLiberacaoConfiancaFalha: false,
        }
    }

    formatarNome() {
        return lodash.truncate(lodash.first(this.props.contratos)?.nomeassinante || "Fulano da Silva", { length: 35 });
    }

    formatarCpf() {
        return utilService.formatCpfCnpj(lodash.first(this.props.contratos)?.cpfCnpj || "11122233344");
    }

    async efetuarLiberacaoEmConfianca() {
        this.setState({liberacaoConfiancaVisivel: false});
        const retorno = await ApiService.liberacaoEmConfianca({
            idcontrato: this.props.contrato.contratoid,
        });
        switch (retorno?.state) {
            case "menu.mensagem.liberacao.em.confianca.realizada":
                this.setState({mostrarLiberacaoConfiancaSucesso: true });
                toast.success("Liberação em Confiança Efetuada com Sucesso.");
            break;
            case "menu.mensagem.liberacao.em.confianca.nao.realizada":
            default:
                this.setState({mostrarLiberacaoConfiancaFalha: true });
                toast.error("Ocorreu um erro na Liberação em Confiança. Contate a nossa central de atendimento.",{
                    autoClose: false,
                    position: "bottom-center",
                    theme: "colored",
                    closeOnClick: true,
                });
        }
    }

    async consultarNumerosContrato(chat){
        const retorno = await ApiService.verificarNumerosAutoAtendimento({
            idcontrato: this.props.contrato.contratoid,
        });
        switch (retorno?.state) {
            case "menu.mensagem.telefones.encontrados.para.contrato":
                this.setState({ escolherNumeroVisivel: true, telefones: retorno.telefones, chat: chat});
            break;
            case "menu.mensagem.nenhum.telefone.encontrado.neste.contrato":
            default:
                toast.error("Nenhum telefone foi encontrado neste contrato. Contate a nossa central de atendimento.",{
                    autoClose: false,
                    position: "bottom-center",
                    theme: "colored",
                    closeOnClick: true,
                });
        }
    }

    async selecionarTelefone(telefone){

        if (this.state.chat){
            const iniciarAtendimento = await ApiService.iniciarAtendimento({
                telefone: telefone.identificacao,
                idOperacaoTotem: this.props.operacaoTotem.id,
                idclientecontrato: this.props.contrato.contratoid,
            });
            toast.success("Em instantes chamaremos você no whatsapp através do telefone escolhido.");
        } else {
            const iniciarAtendimento = await ApiService.meLigue({
                telefone: telefone.identificacao,
                idOperacaoTotem: this.props.operacaoTotem.id,
                idclientecontrato: this.props.contrato.contratoid,
            });
            toast.success("Em instantes ligaremos para o telefone escolhido.");
        }
        this.setState({ escolherNumeroVisivel: false });
    }

    async onSelecionarContrato(){
        this.props.onSuccess && this.props.onSuccess(null); 
        return this.props.navigate("/selecionarcontrato/"+ this.props.operacaoTotem.id);
    }

    render() {
        return (
            <>
                <ul id="progress-bar" className="entry-bookend-progress-container header fundo-contratos">
                    <div className="topo-navegacao">
                        <img alt="Logo da Hay Systems" src={this.props.operacaoTotem.logoPrincipalAutoAtendimento || IconeHay} className={"img-topo-navegacao"} />
                        <p className="nome-usuario-navegacao">{this.formatarNome()}</p>
                        <p className="cpf-usuario-navegacao">{this.formatarCpf()} </p>
                    </div>

                    <span className="entry-bookend-progress-container header" style={{
                        paddingBottom: 0,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        width: "calc(100% - 190px)",
                        fontSize: "xx-large",
                        fontWeight: 900,
                        position: "absolute",
                        bottom: 0
                    }}>

                        <p className="selecao-contrato"> Escolha uma ação: </p>

                        <ul id="progress-bar" className="entry-bookend-progress-container header lista-contratos" style={{ maxHeight: 500, flexDirection: 'column', alignContent: 'center' }}>
                            <div className="menu-split">
                                <a onClick={()=> this.onSelecionarContrato()} className="entry-bookend-progress-container header interior menu" >
                                    <div style={{ flexDirection: 'column' }}>
                                        <p className="menu-inicial"> <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"file-lines"} /> Contratos</p>
                                    </div>
                                    
                                    <a className="botao-contrato" >
                                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"chevron-right"} />
                                    </a>
                                </a>
                               
                                <a className="entry-bookend-progress-container header interior menu" onClick={ ()=> [4,7].indexOf(this.props.contrato?.situacaocodigo) > -1 && this.setState({ liberacaoConfiancaVisivel: true }) } style={[4,7].indexOf(this.props.contrato?.situacaocodigo) > -1 ? { cursor: 'pointer'} : { opacity: 0.5 }} >
                                    <div style={{ flexDirection: 'column' }}>
                                        <p className="menu-inicial" > <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"fa-handshake-angle"}  />  Liberação em Confiança</p>
                                    </div>
                                    
                                    <a className="botao-contrato" >
                                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"chevron-right"} />
                                    </a>
                                </a>
                                 <a className="entry-bookend-progress-container header interior menu" style={this.props.operacaoTotem.falecomigo ? { cursor: 'pointer'} : { visibility: 'hidden' }} onClick={() => this.consultarNumerosContrato(true) } >
                                    <div style={{ flexDirection: 'column' }}>
                                        <p className="menu-inicial"> <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"fa-brands fa-whatsapp"} /> Atendimento</p>
                                    </div>
                                    
                                    <a className="botao-contrato" >
                                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"chevron-right"} />
                                    </a>
                                </a>
                                     
                            </div>
                            <div className="menu-split">
                                <Link to={"/contratoselecionado/" + this.props.operacaoTotem.id} className="entry-bookend-progress-container header interior menu" >
                                    <div style={{ flexDirection: 'column',  }}>
                                        <p className="menu-inicial"> <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"file-invoice-dollar"} /> Faturas</p>
                                    </div>
                                    
                                    <a className="botao-contrato" >
                                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"chevron-right"} />
                                    </a>
                                </Link>
                                <Link to={"/?idOperacaoTotem=" + this.props.operacaoTotem.id} onClick={()=> this.props.aoExpirar() } className="entry-bookend-progress-container header interior menu encerrar-atendimento-inicio" style={{backgroundColor: "#00ADFF"}} >
                                    <div style={{ flexDirection: 'column' }}>
                                        <p className="menu-inicial"> <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"fa-arrow-right-from-bracket"} flip="both"  /> Encerrar</p>
                                    </div>
                                </Link>
                                <a  className="entry-bookend-progress-container header interior menu" style={this.props.operacaoTotem.meligue ? { cursor: 'pointer'} : { visibility: 'hidden' }} onClick={() => this.consultarNumerosContrato() } >
                                    <div style={{ flexDirection: 'column' }}>
                                        <p className="menu-inicial"> <FontAwesomeIcon className='fa-fw icone-resultado' color='white' size="2x" icon={"phone"}  /> Me Ligue</p>
                                    </div>
                                    
                                    <a className="botao-contrato" >
                                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"chevron-right"} />
                                    </a>
                                </a>                                
                                                 
                            </div>
                        </ul>
                    </span>
                </ul>

                <Modal visible={this.state.liberacaoConfiancaVisivel} icon={"credit-card"} title={"Efetuar Liberação"} onClose={() => this.setState({ liberacaoConfiancaVisivel: false }) }>
                    <span className="circle progress-index larguinho" style={{marginBottom: 20}}>
                            <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" title={this.props.contrato?.situacao} icon={"user"} />
                            <span className="index elipsis"> Assinante: {this.props.contrato?.nomeassinante} </span>
                            <p className='linha-contrato'>Endereço: {this.props.contrato?.endereco}</p>
                            <p className='linha-contrato'>Situacao: {this.props.contrato?.situacao} IdAssinante: [{this.props.contrato?.idassinante}] Contrato: [{this.props.contrato?.numerocontrato}] </p>
                            <p>Você pode solicitar a <b>liberação em confiança</b> por mais três dias, até que você regularize a sua situação financeira conosco.</p>
                            <p>Caso o pagamento não seja confirmado em 3 dias úteis, o sinal será
                            reduzido.</p> <br/>
                            <a className="botao-pix botao-autoatendimento secundario"   onClick={() => this.efetuarLiberacaoEmConfianca(this.props.contrato)} style={{marginBottom: 20, marginTop: 20 }}>
                                <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"fa-handshake-angle"}  /> Ativar Liberação
                            </a>
                        </span>
                </Modal>

                <Modal visible={this.state.mostrarLiberacaoConfiancaSucesso} icon={"credit-card"} title={"Liberação com Sucesso"} onClose={() => this.setState({ mostrarLiberacaoConfiancaSucesso: false }) }>
                    <span className="circle progress-index larguinho" style={{marginBottom: 20}}>
                            <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"check"} />
                            <span className="index elipsis"> LIBERAÇÃO EM CONFIANÇA REALIZADA COM SUCESSO </span>
                            <p className='linha-contrato'>Seu sinal será reativado em até 30 minutos</p>
                            <p className='linha-contrato'>{this.props.autorizacao?.mensagemLiberacaoConfianca || 'Caso o pagamento não seja confirmado em 2 dias úteis, o plano será bloqueado novamente.' }</p>                            
                        </span>
                </Modal>

                <Modal visible={this.state.mostrarLiberacaoConfiancaFalha} icon={"credit-card"} title={"Liberação com Falha"} onClose={() => this.setState({ mostrarLiberacaoConfiancaFalha: false }) }>
                    <span className="circle progress-index larguinho" style={{marginBottom: 20}}>
                            <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"times"} />
                            <span className="index elipsis"> Ocorreu um erro na Liberação em Confiança. Contate a nossa Central de Atendimento. </span>
                        </span>
                </Modal>

                <Modal visible={this.state.escolherNumeroVisivel} icon={"phone"} title={"Escolha o numero desejado: "} onClose={() => this.setState({ escolherNumeroVisivel: false }) }>
                    <span className="circle progress-index larguinho" style={{marginBottom: 20}}>
                         <p style={{fontSize: 'large', margin: 10 }}>Escolha o número desejado para prosseguir:</p>
                         <ul id="progress-bar" className="entry-bookend-progress-container header lista-contratos" style={{ overflowY: "auto", alignItems:'flex-start'}}>
                            {
                                this.state.telefones.map(telefone => {
                                    return (
                                        <>
                                            <span className="entry-bookend-progress-container header interior" onClick={() => this.selecionarTelefone(telefone)} style={{height: 80}} >
                                                <div style={{width: "90%"}}>
                                                    <p className="nome-cliente">{telefone?.identificacaoofuscada}</p>
                                                </div>
                                                <a className="botao-contrato" >
                                                    <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"chevron-right"} />
                                                </a>
                                            </span>
                                        </>
                                    )
                                })
                            }
                            </ul>
                        </span>
                </Modal>

                
            </>
        )
    }
}
export default withRouter(MenuInicial);